import React from 'react'

const IconLinkedin = React.forwardRef((props, ref)=>{
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24">
            <g>
                <path ref={ref} id="LinkedIn" d="M3.64,9.13H7.07V20H3.64ZM16.45,9c-2,0-3.2,1.06-3.43,1.81V9.13H9.17c.05.91,0,10.87,0,10.87H13V14.12a2.44,2.44,0,0,1,.09-.89A2,2,0,0,1,15,11.9c1.34,0,1.95,1,1.95,2.48V20H20.8V14C20.8,10.59,18.88,9,16.45,9ZM5.3,4a1.89,1.89,0,1,0,0,3.77h0A1.89,1.89,0,1,0,5.3,4Z" fill="#eff4fb"/>
            </g>
        </svg>
    )
})


export default IconLinkedin